<ng-template let-entity="entity" #actionsTemplate>
  <div class="btn-group" role="group" aria-label="Basic example">
    <button [routerLink]="['delete', entity.getPrimaryKey()]" [queryParams]="{sort: sortParam}" [disabled]="isSupporter"
            class="btn btn-sm btn-outline-danger" ngbTooltip="Tarif löschen" i18n-ngbTooltip="Tarif löschen" placement="top">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
      </span>
    </button>
  </div>
</ng-template>
<div id="pricings">
  <div *ngIf="tableReady" [class]="tableView">
    <app-table [id]="className + 'Table'" [table]="table" [class]="tableFunctions.getTableLayout(className)"></app-table>
  </div>

  <div *ngIf="!tableReady" class="loading-spinner-container">
    <div class="spinner-border text-primary loading-spinner-md" role="status">
      <span class="visually-hidden-focusable">Loading...</span>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
